import { jsx as _jsx } from "react/jsx-runtime";
import { Markdown, Prose } from '@criteria-labs/react-typography';
import { Section } from '../section';
export function EndpointOverviewSection({ endpoint }) {
    return (_jsx(Section, { children: _jsx(Prose, { className: "max-w-none", children: _jsx(Markdown, { children: endpoint.description }) }) }));
}
